import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { MouseEventHandler, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  title: string;
  children: ReactNode;
  loading?: boolean;
  buttons?: {
    cancel?: { text?: string };
    action?: { text?: string; handler?: MouseEventHandler<HTMLButtonElement> };
  };
}

function RoutableModal({ title, children, loading = false, buttons = {} }: Props) {
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const navigate = useNavigate();
  const goBack = () => navigate(-1);

  const { cancel, action } = buttons;

  return (
    <Modal isOpen={isOpen} onClose={onClose} onCloseComplete={goBack}>
      <ModalOverlay />
      <ModalContent borderRadius="2xl">
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose} disabled={loading}>
            {cancel?.text || 'Cancel'}
          </Button>
          <Button colorScheme="purple" onClick={action?.handler} isLoading={loading}>
            {action?.text || 'Continue'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default RoutableModal;
